<div class="page-layout simple">
  <mat-sidenav-container class="particle-page-content-container">
    <!-- CONTENT -->
    <div class="content">

      <div class="analytics-container flex flex-col">
        <div #reportsContainer id="reportsContainer" class="main-content">
        </div>
      </div>
    </div>
    <!-- / CONTENT -->
  </mat-sidenav-container>
</div>
